var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-container"},[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","align-items":"center"},on:{"dblclick":_vm.downloadFile}},[_c('img',{staticStyle:{"cursor":"pointer","margin-bottom":"10px"},attrs:{"src":_vm.path,"width":_vm.width,"height":_vm.height}}),_c('span',[_vm._v(" "+_vm._s(_vm.name)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }